import { RootState } from "store/rootReducer";
import { TSelectedDate } from "./type";

export const selectDate: (state: RootState) => TSelectedDate = (state) =>
  state.selectedDate;
